import BlogMidCTA from "../../../../src/components/BlogMidCTA";
import WorkspacePreview from "../../../../src/components/WorkspacePreview";
import * as React from 'react';
export default {
  BlogMidCTA,
  WorkspacePreview,
  React
};